package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class CollectiveAgreementRepository(private val httpClient: HttpClient) {
    suspend fun getSettings(workplaceId: Long): Result<CollectiveAgreementDto?> = runCatching {
        httpClient.get("workplaces/$workplaceId/collective-agreement").body()
    }

    suspend fun saveSettings(workplaceId: Long, req: SaveCollectiveAgreementRequest): Result<Unit> = runCatching {
        httpClient.put("workplaces/$workplaceId/collective-agreement") { setBody(req) }
    }

    suspend fun getOBBreakdown(workplaceId: Long, from: String, to: String): Result<List<PayrollOBBreakdownDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/ob-breakdown") {
            parameter("from", from)
            parameter("to", to)
        }.body()
    }
}
